import { Component, OnInit, ViewChild } from '@angular/core';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import {saveContent, rutaDocs } from 'src/app/general/variables';

@Component({
  selector: 'app-modal-mp',
  templateUrl: './modal-mp.component.html',
  styleUrls: ['./modal-mp.component.css']
})
export class ModalMpComponent implements OnInit {

  strDscUrlLey = '';
  strDscUrlVerOfic = 'ListaDeOficinas.pdf';
  strDscUrlVerFormato = 'formatoSolicitudMDP.pdf';

  // formModalMP = new FormGroup({
  //   //nro_formulario : new FormControl('')
  // });

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: Parametro,
  // public dialogRef: MatDialogRef<ModalNotificacionComponent>,
  // protected parametroService:ParametroService,

  ) { }

  ngOnInit() {

    this.strDscUrlLey = '29542';

    // this.parametroService.obtenerParametro(NumIdParamLeyMPD).subscribe(data=>{

    //   this.strDscUrlLey = data.cparamValor

    // });


    // this.navModalC.setDatosNavModal2("Instrucciones");

  }

  _abrirUrl(dscNombre: string) {

    // window.open(url, '_blank');

    saveContent(rutaDocs + dscNombre, dscNombre);

  }

  // _cancelar(){

  //   this.dialogRef.close();

  // }


}
